import { render, staticRenderFns } from "./VesselVoyage.vue?vue&type=template&id=4d643865&"
import script from "./VesselVoyage.vue?vue&type=script&lang=js&"
export * from "./VesselVoyage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports